import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PacientesComponent } from './pages/pacientes/pacientes.component';
import { ProntuarioComponent } from './pages/prontuario/prontuario.component';

const routes: Routes = [
  {
    path: '',
    component: PacientesComponent
  },
  {
    path: 'prontuario/:id',
    title: 'Prontuário do Paciente',
    component: ProntuarioComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PacientesRoutingModule {}
